import React, { useState, useEffect } from 'react';
import { animated, useTrail } from '@react-spring/web';
import Box from '@mui/material/Box';

const LoadingBar = () => {
  const [ loading, setLoading ] = useState(true);
  const trail = useTrail( 10 , {
    from: { opacity: 0 },
    to : { opacity: 1 },
    leave: { opacity: 0 },
    trail: 1000, 
    config: { duration: 800 },
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div id="loadingScreen" style={{
      position:'fixed',
      top:0,
      left:0,
      height:'100vh',
      width:'100vw',
      zIndex:'4'
    }} 
    className={loading ? 'true' : 'false'}>
      <div className='wrapper'>
      <Box 
          component="img"
          src={process.env.PUBLIC_URL + '/offset-logo-dark.png'}
          alt="DoorHopper Logo"
          sx={{
            width: '250px',
            height: 'auto',
            mb: 4
          }}
        />
        <div
          style={{
            width: '100%',
            height: '30px',
            border: '2px solid black',
            overflow: 'hidden',
            display: 'flex',
          }}
        >
          {trail.map((props, index) => (
            <animated.div
              key={index}
              style={{
                ...props,
                background: '#127865',
                borderRight: '2px solid black',
                width: '15%',
                marginRight: '5px',
                textAlign: 'center',
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default LoadingBar;


